export const getCurrentShareBaseUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete('cid')
  url.searchParams.delete('ca')
  return url.toString()
}
